<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        text
        rounded
        fab
        color="success"
        :to="{ name: 'UserSupport' }">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-card style="height: 80vh; min-height: 500px;">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdddxlY-Yu0D6N7pE9SZ1ilBXS8SXCGdczy2MfTn6TXLKVjsA/viewform?embedded=true"
          width="100%"
          height="100%"
          frameborder="0"
          marginheight="0"
          marginwidth="0">
          Cargando…
        </iframe>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      section: 'Resportar un bug'
    }
  }
}
</script>
